import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import usePageStore from '../Page/pageStore';
import FixedElement from './FixedElement';
import React from 'react';
import { scrollEnableDelay } from '../globalUtils';
const FixedContainer = ({ idx, allowOpen, blocked, skipIntro, noIntroDelay, hasGradient, lastNoGradient, fastOpenTransition, parentClassName, sliderClassName, elementClassName, extraRevealDelay, openDelay, children, }) => {
    const { activeSection, shownSection, blockSnap } = usePageStore();
    const openDirectionRef = useRef('regular');
    const previouslyShownSection = useRef(shownSection);
    const wrapperRef = useRef(null);
    const textContainerRef = useRef(null);
    const containerPosition = useRef(0);
    const readyToScroll = useRef(false);
    const readyToScrollTimeout = useRef(0);
    const posRef = useRef(0);
    const allowOpenRef = useRef(allowOpen);
    allowOpenRef.current = allowOpen;
    const shownSectionRef = useRef(shownSection);
    shownSectionRef.current = shownSection;
    const blockedRef = useRef(blocked);
    blockedRef.current = blocked;
    const onScroll = () => {
        if (blockedRef.current)
            return;
        if (wrapperRef.current && textContainerRef.current) {
            if (shownSectionRef.current === idx) {
                // this one meant to handle the overscroll delay
                enableScroll();
                if (readyToScroll.current) {
                    const bounds = wrapperRef.current.getBoundingClientRect();
                    const pos = bounds.y; //  * (1 - Math.min(1, Math.abs(bounds.y) / (window.innerHeight * 0.5)));
                    positionContainerOnFrame(pos);
                }
            }
            else {
                positionContainerOnFrame(0);
            }
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [shownSection, idx, activeSection]);
    useEffect(() => {
        readyToScroll.current = false;
        clearTimeout(readyToScrollTimeout.current);
        if (shownSection === idx) {
            enableScroll();
        }
    }, [shownSection, idx]);
    const enableScroll = () => {
        clearTimeout(readyToScrollTimeout.current);
        if (!readyToScroll.current) {
            readyToScrollTimeout.current = window.setTimeout(checkScroll, scrollEnableDelay);
        }
    };
    const checkScroll = () => {
        readyToScroll.current = true;
    };
    const positionContainerOnFrame = (pos, force) => {
        if (pos !== containerPosition.current || force) {
            containerPosition.current = pos;
            requestAnimationFrame(positionContainer);
        }
    };
    function easedClamp(pos, max, buffer) {
        const sign = Math.sign(pos);
        const absPos = Math.abs(pos);
        const limit = max - buffer;
        if (absPos <= limit)
            return pos;
        const t = (absPos - limit) / buffer;
        let eased;
        if (t <= 1) {
            // Within buffer zone: ease out softly (e.g., sine)
            eased = limit + buffer * Math.sin((t * Math.PI) / 2); // easeOutSine
        }
        else {
            // Beyond max: asymptotic continuation
            const overshoot = absPos - max;
            const tail = buffer * (1 - Math.exp(-overshoot / buffer)); // asymptotic approach
            eased = max + tail;
        }
        return sign * eased;
    }
    const positionContainer = () => {
        if (!textContainerRef.current)
            return;
        let pos = containerPosition.current;
        //FIX: animate out when scrolling too big
        if (Math.abs(pos) >= window.innerHeight / 3)
            return;
        if (posRef.current !== pos) {
            posRef.current = pos;
            const maxPosition = window.innerHeight / 8;
            const maxBuffer = window.innerHeight / 2;
            const maxEdge = maxPosition - maxBuffer;
            let posEase = easedClamp(pos, 100, 100);
            textContainerRef.current.style.transform = `translateY(${posEase}px)`;
            textContainerRef.current.dispatchEvent(new CustomEvent('animation', { detail: { pos, posEase } }));
        }
    };
    if (blocked)
        return (_jsx("div", { className: `fixed-container-wrapper-static${parentClassName ? ` ${parentClassName}` : ''}`, children: children }));
    if (previouslyShownSection.current !== shownSection) {
        openDirectionRef.current =
            previouslyShownSection.current < shownSection ? 'regular' : 'inverse';
        previouslyShownSection.current = shownSection;
    }
    const childrenElements = (React.Children.map(children, (child) => child) ??
        []);
    if (!children || !childrenElements.length)
        return null;
    const openDirection = allowOpen && shownSection === idx && activeSection === idx
        ? openDirectionRef.current
        : null;
    return !allowOpen ? null : (_jsx("div", { className: `fixed-container-wrapper${parentClassName ? ` ${parentClassName}` : ''}`, ref: wrapperRef, children: _jsx("div", { className: `fixed-container-slider${sliderClassName ? ` ${sliderClassName}` : ''}`, ref: textContainerRef, children: childrenElements.map((child, i) => (_jsx(FixedElement, { idx: i, openDirection: openDirection, allNum: childrenElements.length, firstPageOpen: !shownSection && openDirection === 'regular' && !noIntroDelay, fastOpenTransition: fastOpenTransition, hasGradient: hasGradient &&
                    !(lastNoGradient && i == childrenElements.length - 1), className: elementClassName, skipIntro: skipIntro, allowOpen: allowOpen, extraRevealDelay: extraRevealDelay, openDelay: openDelay, children: child }, i))) }) }));
};
export default FixedContainer;
